<template>
  <div class="page_fnncsum">
      <div class="crumbs" style="width: 99%">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="项目总计" name="first"></el-tab-pane>
        <el-tab-pane label="人员总计" name="second"></el-tab-pane>
        <el-tab-pane label="总计对比" name="third"></el-tab-pane>
      </el-tabs>
      </div>
     <!-- 财务总计 -->
      <div v-show="totalcount>0&&listQuery.looktype != 3">
        <el-table :data="totalData" :max-height="tableHeight-210" style="width: 99%;" :key="Math.random()" border v-loading="totalLoading">
          <el-table-column align="center" label="NO" prop="OrderNum" v-if="listQuery.looktype == 1" width="60px" :key="Math.random()"></el-table-column>
          <el-table-column align="center" label="记账日期" prop="BookingRealMonth" min-width="90px" fixed="left">
          <template>
            <span>总计</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="归属日期" prop="BelongMonth" min-width="90px" fixed="left">
          <template slot-scope="{row}">
            <span>{{!isNull(row.BelongMonth)?row.BelongMonth:''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目名称" prop="StrObjName" min-width="130px" fixed="left">
            <template slot-scope="{row}">
            <span>{{!isNull(row.StrObjName)?row.StrObjName:''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务中心" prop="StrSrvCent" min-width="130px">
            <template slot-scope="{row}">
            <span>{{!isNull(row.StrSrvCent)?row.StrSrvCent:''}}</span>
          </template>
          </el-table-column>
        <el-table-column align="center" label="子项目" prop="SubProject" v-if="listQuery.looktype == 1" :key="Math.random()">
          <template slot-scope="{row}">
            <span>{{!isNull(row.SubProject)?row.SubProject:''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" v-if="listQuery.looktype == 1" :key="Math.random()">
            <template slot-scope="{row}">
            <span>{{!isNull(row.StrIdCard)?row.StrIdCard:''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="姓名" prop="StrEmpName" fixed="left" v-if="listQuery.looktype == 1" :key="Math.random()">
          <template slot-scope="{row}">
            <span>{{!isNull(row.StrEmpName)?row.StrEmpName:''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="工资收入" prop="Incomewages" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.Incomewages)?row.Incomewages.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="保险收入" prop="IncomeInsurance" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeInsurance)?row.IncomeInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="公积金收入" prop="IncomeFund" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeFund)?row.IncomeFund.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="管理费用收入" prop="IncomeManagement" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeManagement)?row.IncomeManagement.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="招聘费收入" prop="IncomeRecruit" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeRecruit)?row.IncomeRecruit.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="住宿费收入" prop="IncomeStay" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeStay)?row.IncomeStay.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="残保金" prop="IncomeDisabile" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeDisabile)?row.IncomeDisabile.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="其他收入" prop="IncomeOthers" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeOthers)?row.IncomeOthers.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收入小计" prop="IncomeTotal" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.IncomeTotal)?row.IncomeTotal.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="工资支出" prop="Expendwages" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.Expendwages)?row.Expendwages.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="单位保险支出" prop="ExpendUnitInsurance" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendUnitInsurance)?row.ExpendUnitInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="个人保险支出" prop="ExpendPersonInsurance" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendPersonInsurance)?row.ExpendPersonInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="公积金单位支出" prop="ExpendUnitFund" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendUnitFund)?row.ExpendUnitFund.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="公积金个人支出" prop="ExpendPersonFund" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendPersonFund)?row.ExpendPersonFund.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="大商保" prop="LargeBusinessInsurance" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.LargeBusinessInsurance)?row.LargeBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="小商保" prop="SmallBusinessInsurance" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.SmallBusinessInsurance)?row.SmallBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="大小商保" prop="SandLbusinessInsurance" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.SandLbusinessInsurance)?row.SandLbusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="日商保" prop="DayBusinessInsurance" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.DayBusinessInsurance)?row.DayBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
          <el-table-column align="center" label="健康险" prop="HealthInsurance" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.HealthInsurance)?row.HealthInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
          <el-table-column align="center" label="个人承担养老" prop="PersonalPension" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.PersonalPension)?row.PersonalPension.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
          <el-table-column align="center" label="个人承担医疗" prop="PersonalMedical" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.PersonalMedical)?row.PersonalMedical.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="个人承担失业" prop="PersonalUnemployment" min-width="120px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.PersonalUnemployment)?row.PersonalUnemployment.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="个人承担公积金费用" prop="PersonalFund" min-width="140px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.PersonalFund)?row.PersonalFund.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="个人承担社保费用" prop="PersonalBalancePayments" min-width="130px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.PersonalBalancePayments)?row.PersonalBalancePayments.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="个税支出" prop="ExpendRaise" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendRaise)?row.ExpendRaise.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="支出小计" prop="ExpendTotal" min-width="110px">
            <template slot-scope="{row}">
            <span>{{!isNull(row.ExpendTotal)?row.ExpendTotal.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收支结余" prop="BalancePayments" min-width="110px">
          <template slot-scope="{row}">
            <span>{{!isNull(row.BalancePayments)?row.BalancePayments.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="StrRemark" min-width="260px" v-if="listQuery.looktype == 1"></el-table-column>
        </el-table>
      </div>
      <!-- 对比总计 -->
      <!-- <div v-show="totalcount>0&&listQuery.looktype == 3">
        <el-table :data="contrastData" :max-height="tableHeight-210" style="width: 99%" :key="Math.random()" border v-loading="contrastLoading">
           <el-table-column align="center" label="记账日期" prop="BookingRealMonth" min-width="90px" fixed="left">
            <template>
              <span>总计</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属日期" prop="BelongMonth" min-width="90px" fixed="left">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BelongMonth)?row.BelongMonth:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent" fixed="left" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrSrvCent)?row.StrSrvCent:''}}</span>
            </template>
            </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName" fixed="left" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrObjName)?row.StrObjName:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收入小计(项目)" prop="IncomeTotalobj" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeTotalobj)?row.IncomeTotalobj.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收入小计(人员)" prop="IncomeTotalemp" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeTotalemp)?row.IncomeTotalemp.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支出小计(项目)" prop="ExpendTotalobj" min-width="110px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendTotalobj)?row.ExpendTotalobj.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支出小计(人员)" prop="ExpendTotalemp" min-width="110px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendTotalemp)?row.ExpendTotalemp.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收支结余(项目)" prop="BalancePaymentsobj" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BalancePaymentsobj)?row.BalancePaymentsobj.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收支结余(人员)" prop="BalancePaymentsemp" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BalancePaymentsemp)?row.BalancePaymentsemp.toLocaleString(undefined,{minimumFractionDigits:2}):'0.00'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div class="funcsumTable" v-show="activeName=='first'||activeName=='second'">
        <el-table :data="tableData" show-summary :summary-method="getSummaries" :max-height="tableHeight-310" style="width: 99%" :key="Math.random()" border v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
          <!-- <el-table-column align="center" label="序号" prop="IntOrderId" width="100px"></el-table-column> -->
          <el-table-column align="center" label="NO" prop="OrderNum" v-if="listQuery.looktype == 1" width="60px" :key="Math.random()"></el-table-column>
           <el-table-column align="center" label="记账日期" prop="BookingRealMonth" min-width="90px" fixed="left">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BookingRealMonth)?row.BookingRealMonth:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属日期" prop="BelongMonth" min-width="90px" fixed="left">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BelongMonth)?row.BelongMonth:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName" fixed="left" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrObjName)?row.StrObjName:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrSrvCent)?row.StrSrvCent:''}}</span>
            </template>
            </el-table-column>
          <el-table-column align="center" label="子项目" prop="SubProject" v-if="listQuery.looktype == 1" :key="Math.random()">
            <template slot-scope="{row}">
              <span>{{!isNull(row.SubProject)?row.SubProject:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" v-if="listQuery.looktype == 1" :key="Math.random()">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrIdCard)?row.StrIdCard:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="姓名" prop="StrEmpName" fixed="left" v-if="listQuery.looktype == 1" :key="Math.random()">
            <template slot-scope="{row}">
              <span>{{!isNull(row.StrEmpName)?row.StrEmpName:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="工资收入" prop="Incomewages" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.Incomewages)?row.Incomewages.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="保险收入" prop="IncomeInsurance" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeInsurance)?row.IncomeInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="公积金收入" prop="IncomeFund" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeFund)?row.IncomeFund.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="管理费用收入" prop="IncomeManagement" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeManagement)?row.IncomeManagement.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="招聘费收入" prop="IncomeRecruit" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeRecruit)?row.IncomeRecruit.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="住宿费收入" prop="IncomeStay" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeStay)?row.IncomeStay.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="残保金" prop="IncomeDisabile" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeDisabile)?row.IncomeDisabile.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他收入" prop="IncomeOthers" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeOthers)?row.IncomeOthers.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收入小计" prop="IncomeTotal" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeTotal)?row.IncomeTotal.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="工资支出" prop="Expendwages" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.Expendwages)?row.Expendwages.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="单位保险支出" prop="ExpendUnitInsurance" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendUnitInsurance)?row.ExpendUnitInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="个人保险支出" prop="ExpendPersonInsurance" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendPersonInsurance)?row.ExpendPersonInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="公积金单位支出" prop="ExpendUnitFund" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendUnitFund)?row.ExpendUnitFund.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="公积金个人支出" prop="ExpendPersonFund" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendPersonFund)?row.ExpendPersonFund.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="大商保" prop="LargeBusinessInsurance" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.LargeBusinessInsurance)?row.LargeBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="小商保" prop="SmallBusinessInsurance" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.SmallBusinessInsurance)?row.SmallBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="大小商保" prop="SandLbusinessInsurance" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.SandLbusinessInsurance)?row.SandLbusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="日商保" prop="DayBusinessInsurance" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.DayBusinessInsurance)?row.DayBusinessInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
           <el-table-column align="center" label="健康险" prop="HealthInsurance" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.HealthInsurance)?row.HealthInsurance.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
           <el-table-column align="center" label="个人承担养老" prop="PersonalPension" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.PersonalPension)?row.PersonalPension.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
           <el-table-column align="center" label="个人承担医疗" prop="PersonalMedical" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.PersonalMedical)?row.PersonalMedical.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="个人承担失业" prop="PersonalUnemployment" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.PersonalUnemployment)?row.PersonalUnemployment.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="个人承担公积金费用" prop="PersonalFund" min-width="140px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.PersonalFund)?row.PersonalFund.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="个人承担社保费用" prop="PersonalBalancePayments" min-width="130px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.PersonalBalancePayments)?row.PersonalBalancePayments.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="个税支出" prop="ExpendRaise" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendRaise)?row.ExpendRaise.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支出小计" prop="ExpendTotal" min-width="110px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendTotal)?row.ExpendTotal.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收支结余" prop="BalancePayments" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BalancePayments)?row.BalancePayments.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注" prop="StrRemark" min-width="260px" v-if="listQuery.looktype == 1"></el-table-column>
          <!-- <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <button class="changeState" style="margin-right:10px" @click="editImportFiled(scope.row)">修改</button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block" style="width: 99%">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
           @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(listQuery.pagecount)"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
      <!-- 总计对比 -->
      <div class="funcsumTable" v-show="activeName=='third'">
        <el-table :data="tableData" show-summary :summary-method="getSummaries" :max-height="tableHeight-210" style="width: 99%" :key="Math.random()" border v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
          <!-- <el-table-column align="center" label="序号" prop="IntOrderId" width="100px"></el-table-column> -->
           <el-table-column align="center" label="记账日期" prop="BookingRealMonth" min-width="90px" fixed="left">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BookingRealMonth)?row.BookingRealMonth:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属日期" prop="BelongMonth" min-width="90px" fixed="left">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BelongMonth)?row.BelongMonth:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName" fixed="left" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrObjName)?row.StrObjName:''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent" min-width="130px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.StrSrvCent)?row.StrSrvCent:''}}</span>
            </template>
            </el-table-column>
          <el-table-column align="center" label="收入小计(项目)" prop="IncomeTotalobj" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeTotalobj)?row.IncomeTotalobj.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收入小计(人员)" prop="IncomeTotalemp" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.IncomeTotalemp)?row.IncomeTotalemp.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支出小计(项目)" prop="ExpendTotalobj" min-width="110px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendTotalobj)?row.ExpendTotalobj.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支出小计(人员)" prop="ExpendTotalemp" min-width="110px">
             <template slot-scope="{row}">
              <span>{{!isNull(row.ExpendTotalemp)?row.ExpendTotalemp.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收支结余(项目)" prop="BalancePaymentsobj" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BalancePaymentsobj)?row.BalancePaymentsobj.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="收支结余(人员)" prop="BalancePaymentsemp" min-width="110px">
            <template slot-scope="{row}">
              <span>{{!isNull(row.BalancePaymentsemp)?row.BalancePaymentsemp.toLocaleString(undefined,{minimumFractionDigits:2}):'-'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="width: 99%">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(listQuery.pagecount)"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
  </div>
</template>
<script>
import xz from "./../common";
import { parseTime } from './../utils' //格式化时间格式
export default {
    props: {
    toChildrenData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      // 总计数据
      totalData:[],
      totalLoading:false,
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight:0,
      listLoading:false,
      totalcount: null,
      tableData: [],
      //列表参数
      listQuery:{
        pagecount: 10,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        strSrvCent:'',//服务中心
        looktype:2 //1 人员总计详情  2 项目总计
      },
      //项目总计参数
      objQuery:{
        pagecount: 1000000,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        strSrvCent:'',//服务中心
        looktype:2 //1 人员总计详情  2 项目总计
      },
      //切换tab
      activeName: 'first',
      //导出参数
      exportQuery:{
        pagecount: 1000000,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        looktype:2 //1 人员总计详情  2 项目总计
      },
      //导出按钮加载状态
      exportLoading:false,
      //关账弹出框
      dialogVisible:false,
      //关账人员类型 1能关账
      closeAccountType:'',
      //人员角色
      loginRoletype:'',
      //下拉服务中心列表
      serviceList: [],
      isActive: 0,
      //下拉筛选
      showDropScreen: -1,
      //对比参数
      contrastData:[],
      contrastLoading:false,
      contrastQuery:{
        pagecount: 1000000,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        strSrvCent:'',//服务中心
        looktype:3 //1 人员总计详情  2 项目总计 3总计对比
      }
    }; 
  },
  async created() {
    this.closeAccountType = localStorage.closeAccountType
    this.loginRoletype = localStorage.loginRoletype
    this.listQuery.bookingRealMonth = parseTime(new Date(), '{y}-{m}')
    this.listQuery.belongMonth = parseTime(new Date(), '{y}-{m}')
    this.calHeight()
    //父组件传的值
    this.listQuery = this.toChildrenData
    this.getList(this.toChildrenData)
    if(this.listQuery.looktype == 2){
      this.getObjList()
    }
  },
  methods: {
      //切换tab
    async handleClick(tab) {
      // console.log('tab',tab, event);
      this.listQuery.currpage = 1
      this.exportQuery.currpage = 1
      if(tab.index == '0'){
        //项目总计
        this.listQuery.looktype = 2
        this.exportQuery.looktype = 2
        this.objQuery.looktype = 2
        this.getObjList()
        this.getList()
      }else if(tab.index == '1'){
        //人员总计
        this.listQuery.looktype = 1
        this.exportQuery.looktype = 1
        this.objQuery.looktype = 1
        this.getList()
      }else if(tab.index == '2'){
        //人员总计
        this.listQuery.looktype = 3
        this.exportQuery.looktype = 3
        this.objQuery.looktype = 3
        // this.getContrastList()
        this.getList()
      }
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height',this.tableHeight) 
    },
    //表格合计方法
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      // console.log(columns, data, "columns,data");
      columns.forEach((column, index) => {
        if(this.listQuery.looktype!=3){
          if (index === 0) {
            sums[index] = "小计";
            return
          }
          // index >= 3 || index <= 11 是你需要计算的列
          // 当然也可以指定一个或者多个列
          // index === 2 || index === 3 这样值求和第二个与第三个列
          else if (((index>3)&&(this.listQuery.looktype == 2))||((index >= 8 && index <= 37)&&(this.listQuery.looktype == 1))) {
            const values = data.map((item) => Number(item[column.property]));
            if ((!values.every((value) => isNaN(value)))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                // console.log('gggg',prev,curr)
                //将有千分位逗号的值去掉逗号并转为数字类型
                prev = Number(prev.toString().replace(/,/gi,''))
                if (!isNaN(value)) {
                  return (prev +  Number(curr)).toLocaleString(undefined,{minimumFractionDigits:2})
                } else{
                  return prev.toLocaleString(undefined,{minimumFractionDigits:2})
                }
              }, 0);
            }
          }
          // else if(values.every((value) => value=='0.00')){
          //   sums[index] = "-"
          // }
          else {
            sums[index] = "";
          }
        }else{
          if (index === 0) {
            sums[index] = "小计";
            return
          }
          else if (index>3) {
            const value1 = data.map((item) => Number(item[column.property]));
            if ((!value1.every((value) => isNaN(value)))) {
              sums[index] = value1.reduce((prev, curr) => {
                const value2 = Number(curr);
                //将有千分位逗号的值去掉逗号并转为数字类型
                prev = Number(prev.toString().replace(/,/gi,''))
                if (!isNaN(value2)) {
                  return (prev +  Number(curr)).toLocaleString(undefined,{minimumFractionDigits:2})
                } else{
                  return prev.toLocaleString(undefined,{minimumFractionDigits:2})
                }
              }, 0);
            }
          }
          else {
            sums[index] = "";
          }
          }
        });
        // console.log('sum',sums)
        return sums;
    },
    //列表
    async getList(){
      this.listLoading = true
      this.tableData = []
      if(this.listQuery.looktype == 1){
        this.totalData = []
      }
      // console.log('hh',this.listQuery)
      xz.getfinancetotalDatacus(this.listQuery).then(res =>{
        if(res&&res.msg.length>0){
           res.msg.forEach(l => {
            if(!this.isNull(l.StrIdCard)&&l.StrIdCard.indexOf('-')>-1){
              let arr = l.StrIdCard.split('-')
              l["StrIdCard"] = arr[0];
            }
          });
          this.tableData = res.msg;
          this.totalcount = parseInt(res.totalcount);
          if(this.listQuery.looktype == 1){
            this.totalData =res.alltotal
          }
        }else{
          this.tableData = []
          this.totalcount = 0
          if(this.listQuery.looktype == 1){
            this.totalData = []
          }
        }
        this.$emit('func', this.tableData)
        this.listLoading = false
      })
    },
    //项目总计
    getObjList(){
      this.totalLoading = true
      this.totalData = []
      this.objQuery.bookingRealMonth = this.listQuery.bookingRealMonth
      this.objQuery.belongMonth = this.listQuery.belongMonth
      this.objQuery.strSrvCent = this.listQuery.strSrvCent
      this.objQuery.custname = this.listQuery.custname
      if(this.listQuery.looktype == 2){
        this.objQuery.pagecount = 100000
      }else{
        this.objQuery.pagecount = 10
      }
      // console.log('hh',this.listQuery)
      xz.getfinancetotalDatacus(this.objQuery).then(res =>{
        if(res&&res.msg.length>0){
          this.totalData = res.alltotal
        }else{
          this.totalData = []
        }
        this.totalLoading = false
      })
    },
    //对比总计
    getContrastList(){
      this.contrastLoading = true
      this.contrastData = []
      this.contrastQuery.bookingRealMonth = this.listQuery.bookingRealMonth
      this.contrastQuery.belongMonth = this.listQuery.belongMonth
      this.contrastQuery.strSrvCent = this.listQuery.strSrvCent
      this.contrastQuery.custname = this.listQuery.custname
      if(this.listQuery.looktype == 3){
        this.contrastQuery.pagecount = 100000
      }else{
        this.contrastQuery.pagecount = 10
      }
      // console.log('hh',this.listQuery)
      xz.getfinancetotalDatacus(this.contrastQuery).then(res =>{
        if(res&&res.msg.length>0){
          this.contrastData = res.alltotal
        }else{
          this.contrastData = []
        }
        this.contrastLoading = false
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.currpage = parseInt(val);
      this.getList();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1
        this.listQuery.pagecount = parseInt(val);
        this.getList();
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right{
margin-right: 16px;
}
.crumbs {
    margin-top: 20px;
    margin-bottom: 1px;
    background-color: #fff;
}
.page_breads{
  margin-top: 20px;
}
</style>
<style>
.page_fnncsum .formScreenInput .el-input__inner{
  width: 210px;
}
.page_fnncsum .el-tabs__header{
    margin: 0;
}
.page_fnncsum .screenInput .el-input{
    width: 180px;
}
.page_fnncsum .screenInput .el-date-editor.el-input{
    width: 130px;
}
.page_fnncsum .el-date-editor .el-input__inner{
height: 32px;
line-height: 32px;
}
.page_fnncsum .el-date-editor .el-input__icon{
    line-height: 33px;
}
.page_fnncsum .el-select .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.page_fnncsum .el-select .el-input__icon{
  line-height: 32px;
}
</style>